import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "frame"]
  static values = { emptyMessage: String }

  connect() {
    this.onModalHidden = this.resetFrame.bind(this)
    this.modalTarget.addEventListener("hidden.bs.modal", this.onModalHidden)
  }

  disconnect() {
    this.modalTarget.removeEventListener("hidden.bs.modal", this.onModalHidden)
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url
    if (!url) return
    this.frameTarget.src = url
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  resetFrame() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = ""
    const p = document.createElement("p")
    p.className = "text-muted small mb-0 py-3 text-center"
    p.textContent = this.emptyMessageValue
    this.frameTarget.appendChild(p)
  }
}
